import React, {Component} from 'react';
import request from './request'
import tipAlert from "../BsyAlertTip/Staticize";
import { BsyUtils } from '../../utils/Utils'

class DingdingCode extends Component {
    constructor(props){
        super(props)
        this.state = {
            // 你们申请的appid
            APPID: props.APPID,
            // 跳转当前页面
            REDIRECT_URI: encodeURIComponent(`${window.sitesetting.HOST}${window.root_directroy ? window.root_directroy + '/' : ''}dingding/dd_or_code_corp_list${window.data_config.team_data ? ("?teamId="+window.data_config.team_data.corp + (window.data_config.team_data.type ? ("&type="+window.data_config.team_data.type):"")):""}`)//http://XXX/#/login 你的登录页面
        }
    }

    componentDidMount () {
        let URL=encodeURIComponent(`https://oapi.dingtalk.com/connect/oauth2/sns_authorize?appid=${this.state.APPID}&response_type=code&scope=snsapi_login&state=STATE&redirect_uri=${this.state.REDIRECT_URI}`)
        // 实例化对象
        window.DDLogin({
            id:"login_container",
            goto: URL,
            style: "border:none;background-color:transparent;",
            width : "100%",
            height: "310"
        });
        // 监听消息处理方法
        const handleMessage = (event) => {
            // 获取loginTempCode
            const loginTempCode = event.data;
            // 获取消息来源
            const origin = event.origin;
            // 拼接 url
            const url = `https://oapi.dingtalk.com/connect/oauth2/sns_authorize?appid=${this.state.APPID}&response_type=code&scope=snsapi_login&state=dinglogin&redirect_uri=${this.state.REDIRECT_URI}&loginTmpCode=${loginTempCode}`
            // 如果来源为https://login.dingtalk.com，则在当前窗口打开回调链接
            if (origin === 'https://login.dingtalk.com') {
                BsyUtils.redirectTo(encodeURI(url), '_parent')
            }
        };
        // 监听iframe的消息
        if (typeof window.addEventListener != 'undefined') {
            window.addEventListener('message', handleMessage, false);
        } else if (typeof window.attachEvent != 'undefined') {
            window.attachEvent('onmessage', handleMessage);
        }

        //params为地址栏路由后面的参数（我这里是从 父组件中传过来的）
        const {params}=this.props;
        //手机钉钉扫码后 确认登录 成功后 网页地址栏会出现一个参数：state='dinglogin'
        if(params.state==='dinglogin'){
            //同时出现参数code （因为我们需要拿到这个参数 传给后台来获取用户信息）判断后再进行下一步操作
            if(params.code||params['?code']){
                let code=params.code ?params.code :params['?code']
                let parameter={jsCode:code,externalType:2}
                //在这里调用接口 获取用户信息，拿到返回结果，判断是否需要调用自己的登录接口
                request.getExternalOpenId(parameter, data=>{
                    if (data.data.status === 200) {
                        if(data.data.data.isRegist===true){
                            //手机号关联过系统中注册的账号 就进行下一步
                            login(data.data.data.openId);
                        }else{
                            //弹出提示 并且保持登录页 注册账号
                            tipAlert({
                                type: "error",
                                msg : '请先到个人中心关联手机号'
                            })
                            this.props.history.push(window.rootDirectroy + '/login')
                        }
                    } else {
                        tipAlert({
                            type: "error",
                            msg : data.data.message
                        })
                    }
                })
            }
        }
        const login=(openId)=>{
            let params={
                openId:openId,
                // ...other_params  //其他后台需要的参数
            }
            request.loginExternal(params, response => {
                if (response.data.status === 200) {
                    //跳转你要去的系统页面
                    this.props.history.push(window.rootDirectroy + '/index')
                } else {
                    tipAlert({
                        type: "error",
                        msg : response.data.message
                    })
                }

            })
        }
    }
    render(){
        return (
            <div className="dingdingLoginBox">
                <div id='login_container'>

                </div>
            </div>
        )
    }
}

export default DingdingCode;